module.exports = __webpack_public_path__ + "static/hhb-reel-preview-532f6a6f9197e2a0cbb1c45eac6c5a5e.mp4";